import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProfileEstimation } from "../types";

export const getProfileEstimations = (billingProfileId: string) =>
  apiProxyRequest<ProfileEstimation>(
    `/billing/profiles/${billingProfileId}/estimate?current_month=true`
  );
